import React from "react";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import { useLocation } from "react-router-dom";
import HeroSection from "../../layout/HeroSection";
import SecureContent from "../../components/secureContent";

const Testing = () => {
  const { data } = useLocation()?.state;
  const getLink = (detail)=>{
    if (detail?.type === "doc") {
        return detail?.embed_link.replace("/edit", "/preview");
      } else if (detail?.type === "slide") {
        return detail?.embed_link.replace("/edit#slide=id.p", "/embed");
      }
  }

  return (
    <>
      <div>
      <SecureContent/>
        <Header />
        <HeroSection label={<h1 class="mb-3">{data?.title ?? ""}</h1>} />
        <div className="container">
          <div className="row">
            <div className="col-md-10 mx-auto untree_co-section pt-5 pb-5 ">
              <div className=" position-relative">
                <iframe
                  width="100%"
                  height="700px"
                  src={getLink(data)}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {/* <img src={data.image} alt={data.title} /> */}
                  <h5>{data.title}</h5>
                </iframe>

                <a
                  className="ct_frame_direct_link_icon"
                  href={data.embed_link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i class="fa-solid fa-up-right-from-square"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
};

export default Testing;
